import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from '@/App';
import '@/styles/globals.css';
import { initSentry, SentryErrorBoundary } from '@/lib/sentry';

// Must be called before React mount so SDK sees all errors from first render.
// No-op when VITE_SENTRY_DSN is not set.
initSentry();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found in index.html');

createRoot(rootEl).render(
  <StrictMode>
    <SentryErrorBoundary fallback={<div>Произошла непредвиденная ошибка. Перезагрузите страницу.</div>}>
      <App />
    </SentryErrorBoundary>
  </StrictMode>,
);
